export const useCountryStore = defineStore("countryStore", {
  state: () => ({
    countries: [] as Country[],
  }),
  getters: {
    countryIconUrl: (state) => {},
    countryPhoneCodeList: (state) => {
      return state.countries.map((countryData) => {
        return {
          name: countryData.name,
          local_name: countryData.local_name,
          iso2: countryData.iso2,
          phone_code: Number(countryData.phone_code),
        };
      });
    },
  },
  actions: {
    async fetchCountries() {
      if (this.countries.length > 0) {
        return;
      }

      const { data } = await useSupabaseClient()
        .from("countries")
        .select()
        .order("name", { ascending: true });

      if (data != null && data != undefined) {
        this.countries = data;
      }
    },

    getCountryByIso2(iso2: string | undefined | null): Country | null {
      if (this.countries.length == 0 || !iso2) {
        return null;
      }

      return this.countries.find((country) => {
        return country.iso2.toLowerCase().trim() == iso2.toLowerCase().trim();
      });
    },

    getCountryIconUrl(iso2: string | undefined | null): string {
      if (this.countries.length == 0 || !iso2) {
        return "";
      }

      return (
        "https://raw.githubusercontent.com/lipis/flag-icons/main/flags/1x1/" +
        iso2.toLowerCase() +
        ".svg"
      );
    },
  },
});

export interface Country {
  id: string;
  name: string;
  phone_code: number;
  iso2: string;
  local_name: string;
  continent: string;
}
